import * as _4 from 'lodash4';

class MyIntakeHistoryModel {
  public model: object;

  constructor() {
    this.model = {};
  }

  update(item: object, selectedItems: object[]): void {
    _4.set(this.model, item, selectedItems);
  }
}

angular.module('major-explorer-data').provider('myIntakeHistoryModel', () => {
  return {
    $get: () => {
      return new MyIntakeHistoryModel();
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/models/my_intake_history_model.ts